export default __webpack_public_path__ + "static/media/TheOpportunity_checked.3d5ebce0.svg";